<div mat-dialog-title class="ds">
  <span id="dialogTitle"> {{ title }} </span>
  <button id="closeDialogButton" mat-icon-button class="close-dialog-button" mat-dialog-close>
    <mat-icon class="close-icon">close</mat-icon>
  </button>
</div>
<div id="projectContainer" mat-dialog-content class="content ds dialog" [ngClass]="{'mobile': isMobile}">
  @if (loading) {
    <div class="loading">
      <ds-progress-spinner id="loading" progress_mode="indeterminate"></ds-progress-spinner>
    </div>
  }
  @if (!loading) {
    <div class="edit-project-container">
      <form [formGroup]="editProjectForm">
        <div class="container">
          <div class="content">
            <ds-autocomplete id="projectOwner" class="fill-width" [ngClass]="{'half-width': !isMobile}" [options]="accountManagers" [label]="appStrings.followUp_projects_owner" label_orientation="vertical-label" [control]="editProjectForm.controls.projectOwnerId"></ds-autocomplete>
          </div>
          <div class="content">
            <ds-textfield id="companyName" [ngClass]="isMobile ? 'fill-width' : 'quarter-width'" [label]="appStrings.followUp_projects_companyName" label_orientation="vertical-label" [control]="editProjectForm.controls.companyName"></ds-textfield>
            <ds-select id="industrySegment" class="fill-width" [ngClass]="{'half-width': !isMobile}" [label]="appStrings.followUp_projects_indSegment" [dropOptions]="industrySegments" label_orientation="vertical-label" [control]="editProjectForm.controls.industrySegmentId"></ds-select>
          </div>
          <ds-divider></ds-divider>
          <div class="content no-title">
            <ds-textfield id="projectName" class="fill-width" [ngClass]="{'half-width': !isMobile}" [label]="appStrings.followUp_projects_projectName" label_orientation="vertical-label" [control]="editProjectForm.controls.projectName"></ds-textfield>
          </div>
          <div class="content">
            <ds-autocomplete-chips id="projectType" class="fill-width" [label]="appStrings.followUp_projects_projectType" [options]="types" label_orientation="vertical-label" [control]="editProjectForm.controls.projectTypeIds"></ds-autocomplete-chips>
            <ds-textfield id="projectDetails" class="fill-width" [label]="appStrings.followUp_projects_projectDetails" label_orientation="vertical-label" [control]="editProjectForm.controls.projectAndProductDetails"></ds-textfield>
          </div>
          <div class="content">
            <ds-select id="projectStatus" [ngClass]="isMobile ? 'fill-width' : 'quarter-width'" (selectionChange)="handleStatusChange()" [label]="appStrings.followUp_projects_projectStatus" [dropOptions]="statuses" [label_orientation]="'vertical-label'" [control]="editProjectForm.controls.projectStatusId"></ds-select>
            @if (isStatusNoteVisible) {
              <ds-multiline id="statusNotes" class="fill-width spaced-bottom" [ngClass]="{'half-width': !isMobile}" [label]="appStrings.followUp_leads_statusNotes" label_orientation="vertical-label" [control]="editProjectForm.controls.projectStatusNote"></ds-multiline>
            }
          </div>
          <div class="content">
            <ds-select id="estimatedSalesMonth" class="quarter-width" [label]="appStrings.followUp_projects_estimatedSalesMonth" [dropOptions]="months" label_orientation="vertical-label" [control]="editProjectForm.controls.estimatedSalesMonth"></ds-select>
            <ds-select id="estimatedSalesYear" class="quarter-width" [label]="appStrings.followUp_projects_estimatedSalesYear" [dropOptions]="years" label_orientation="vertical-label" [control]="editProjectForm.controls.estimatedSalesYear"></ds-select>
            <ds-select id="confidenceToClose" class="quarter-width" [label]="appStrings.followUp_projects_confidenceToClose" [dropOptions]="confidenceToCloseNames" label_orientation="vertical-label" [control]="editProjectForm.controls.confidenceToClose"></ds-select>
            <ds-textfield id="estimatedSalesValue" class="quarter-width" start_adornment_type="text" [start_adornment_value_text]="currencySign" [label]="appStrings.followUp_projects_estimatedSalesValue" label_orientation="vertical-label" [control]="editProjectForm.controls.estimatedSalesValue"></ds-textfield>
          </div>
          <ds-divider></ds-divider>
          <div class="content no-title">
            <ds-textfield id="contactName" class="quarter-width" [label]="appStrings.followUp_projects_contactName" label_orientation="vertical-label" [control]="editProjectForm.controls.contactName"></ds-textfield>
            <ds-textfield id="contactEmail" class="quarter-width" [label]="appStrings.followUp_projects_contactEmail" label_orientation="vertical-label" [control]="editProjectForm.controls.contactEmail"></ds-textfield>
            <ds-textfield id="contactPhone" class="quarter-width" [label]="appStrings.followUp_projects_contactPhone" label_orientation="vertical-label" [control]="editProjectForm.controls.contactPhoneNumber"></ds-textfield>
            <ds-select id="saleType" class="quarter-width" [label]="appStrings.followUp_projects_saleType" [dropOptions]="saleTypes" label_orientation="vertical-label" [control]="editProjectForm.controls.saleTypeId"></ds-select>
          </div>
          <div class="content">
            @if (isDistributorNameVisible()) {
              <ds-textfield id="distributorName" class="fill-width" [ngClass]="{'half-width': !isMobile}" [label]="appStrings.followUp_projects_distributorName" label_orientation="vertical-label" [control]="editProjectForm.controls.distributorName"></ds-textfield>
            }
            <ds-switch id="techResourcesNeeded" [ngClass]="{'spaced-bottom': !isEdit && !isDistributorNameVisible()}" class="switch" [label]="appStrings.followUp_projects_techResourcesNeeded" variant="small" withIcon="no-icon" [control]="editProjectForm.controls.techResourcesNeeded"></ds-switch>
          </div>
          @if (!isEdit) {
            <ds-divider></ds-divider>
          }
          <div class="content no-title">
            @if (!isEdit) {
              <ds-multiline id="notes" class="fill-width" [label]="appStrings.label_notes" label_orientation="vertical-label" [control]="editProjectForm.controls.note"></ds-multiline>
            }
          </div>
          @if (isEdit) {
            <ds-divider></ds-divider>
          }
          @if (isEdit) {
            <div>
              <div class="content no-title">
                <div class="display-field" id="createdDate">
                  <typography variant="mat-body-2" id="dateLabel" weight="medium">{{appStrings.followUp_leads_date}}</typography>
                  <typography variant="mat-body-2" id="date" weight="regular">{{date | date: dateFormat}}</typography>
                </div>
                <div class="display-field" id="lastUpdated">
                  <typography variant="mat-body-2" id="lastUpdatedLabel" weight="medium">{{appStrings.followUp_leads_lastUpdated}}</typography>
                  <typography variant="mat-body-2" id="lastUpdated" weight="regular">{{lastUpdated | dateAgo }}</typography>
                </div>
              </div>
              <ds-divider></ds-divider>
              <div class="title">
                <typography variant="mat-body-2" id="notesTitle" weight="medium">
                  {{ appStrings.contacts_notes }}
                </typography>
              </div>
              <div class="content">
                <app-project-notes [notes]="notes" [projectId]="projectDetails.projectId" [isView]="isView" class="full-width"></app-project-notes>
              </div>
            </div>
          }
        </div>
      </form>
    </div>
  }
</div>
<div mat-dialog-actions align="end" class="ds">
  <div class="dialog-btn-wrapper">
    @for (button of buttons; track button; let i = $index) {
      <ds-button id="dialogButton_{{i}}" variant="label-only" size="medium"
        [type]="button.type" (onClick)="btnCallback(i)" [label]="button.label">
      </ds-button>
    }
  </div>
</div>
